import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import FORMATS from '../utils/formats';

function InputClabe(props) {
  const { name, inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      format={FORMATS.CLABE}
      getInputRef={inputRef}
      isNumericString
      mask="#"
      onValueChange={({ value }) => {
        onChange({
          target: {
            name,
            value,
          },
        });
      }}
    />
  );
}

InputClabe.propTypes = {
  name: PropTypes.string,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
};

export default InputClabe;
